// Generated by CoffeeScript 1.6.3
(function() {
  rjm.model.GAConnection = Backbone.RelationalModel.extend({
    initialize: function(options) {
      if (!options.hasOwnProperty("id") || !options.hasOwnProperty("meta") || !options.meta.hasOwnProperty("name")) {
        throw "InvalidConstructorArgs - GAConnection";
      }
      this.set({
        'gaid': 'ga' + this.get('id')
      });
      this.set({
        'name': this.get('meta').name
      });
    }
  });

  rjm.model.GAConnectionList = Backbone.Collection.extend({
    model: rjm.model.GAConnection
  });

}).call(this);
